import { useDense } from "./useDense";
import { useWindowSize } from "./useWindowSize";
import { WindowSize } from "./WindowSize";
import { OverridableStringUnion } from "@mui/types";
import { SizeClass } from "./SizeClass";
import { useMemo } from "react";
import {
  TextFieldPropsSizeOverrides,
  ToolbarPropsVariantOverrides,
} from "@mui/material";

export type Toolbar_variant = OverridableStringUnion<
  "regular" | "dense",
  ToolbarPropsVariantOverrides
>;

export type TextField_size = OverridableStringUnion<
  "small" | "medium",
  TextFieldPropsSizeOverrides
>;

export interface UseResponsiveType {
  dense: boolean;
  window: WindowSize;
  component: {
    size: "small" | "medium" | "large";
  };
  textField: {
    size: TextField_size;
  };
  toolbar: {
    variant: Toolbar_variant;
  };
}

export const useResponsive = (): UseResponsiveType => {
  const windowSize = useWindowSize();
  const dense = useDense();

  return useMemo(() => {
    const componentSize =
      windowSize.windowWidth === SizeClass.Compact
        ? "large"
        : windowSize.windowWidth === SizeClass.Medium
        ? "medium"
        : "small";

    const textFieldSize =
      windowSize.windowWidth === SizeClass.Compact
        ? "medium"
        : windowSize.windowWidth === SizeClass.Medium
        ? "medium"
        : "small";

    return {
      window: windowSize,
      dense: dense,
      component: { size: componentSize },
      textField: { size: textFieldSize },
      toolbar: {
        variant: dense ? "dense" : "regular",
      },
    };
  }, [windowSize, dense]);
};
